import { QueryClient, useMutation, useQueryClient } from '@tanstack/react-query';
import type { BrandGroupRequest } from '@brand24-original/llm-types';
import { setBrandGroup } from '../../../../services/monitor/keywords/KeywordsService';
import { invalidateBrandStats } from '../../../query/invalidateBrandStats';

/**
 * Każda zmiana grupowania (przypięcie, odpięcie, odłączenie marki) zmienia to, po czym liczą
 * statystyki — wszystkie, jak po zmianie statusu. Etykieta (`useSetBrandLabel`) rusza tylko listę.
 */
export const invalidateBrandGrouping = (queryClient: QueryClient): void => {
  void invalidateBrandStats(queryClient);
};

export const useSetBrandGroup = (projectId: number, options?: { onError?: () => void }) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (request: BrandGroupRequest) => setBrandGroup(request),
    onSuccess: () => invalidateBrandGrouping(queryClient),
    onError: () => options?.onError?.(),
  });
};
